import { Component, Input, OnInit } from '@angular/core';
import { DeviceBehfaRef_Interface, Empty_DeviceBehfaRef_Interface } from 'src/app/Interface/DeviceBehfaRef_Interface';
import { DeviceBehfaRefService } from 'src/app/Service/DeviceBehfa/DeviceBehfaRef.service';

@Component({
  selector: 'app-DeviceBehfaRefView',
  templateUrl: './DeviceBehfaRefView.component.html',
  styleUrls: ['./DeviceBehfaRefView.component.scss']
})
export class DeviceBehfaRefViewComponent implements OnInit {

  @Input() inner_behfa_id:number=0

  constructor(
    private DeviceBehfaRef_Service:DeviceBehfaRefService,

  ) { }

  ngOnInit() {
    this.CheckOfftime()
  }

  selected_record:DeviceBehfaRef_Interface=Empty_DeviceBehfaRef_Interface()



  CheckOfftime(){

    this.DeviceBehfaRef_Service.GetSingle(this.inner_behfa_id).subscribe(
      data=>{


        this.selected_record=data

      }
    )
  }
}
